var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar",class:_vm.obbjClass,style:(("width: " + (_vm.value || 0) + "%")),attrs:{"role":"progressbar","aria-valuenow":_vm.value,"aria-valuemin":_vm.min,"aria-valuemax":_vm.max}})}
var staticRenderFns = []

export { render, staticRenderFns }